import { defineMeta } from '@/registry/types';

export const transferListMeta = defineMeta({
  name: 'TransferList',
  level: 'organism',
  category: 'input',
  classification: 'custom',
  description: 'Two-list picker for moving items between available and selected sets.',
  baseLibrary: 'custom',
  muiEquivalent: 'List + Checkbox (composed)',
  muiDocs: 'https://mui.com/material-ui/react-transfer-list/',
  a2uiEquivalent: 'DualListBox',
  importPath: '@/organisms/TransferList',
  requiredProps: ['items'],
  optionalProps: ['defaultSelected', 'onChange', 'leftTitle', 'rightTitle'],
  supportedStates: ['default', 'checked', 'empty'],
  designTokens: ['colors', 'spacing'],
  accessibility: ['Items are toggle buttons with checkboxes; move buttons disable when nothing is checked.'],
  usageExamples: ['<TransferList items={items} defaultSelected={["IAM"]} onChange={set} />'],
  antiPatterns: ['Do not use for very large lists (use Autocomplete multiple).'],
  llmSafe: true,
  whenToUse: ['Assigning items to groups/roles/scopes'],
  whenNotToUse: ['Single or few selections (use Checkbox/Autocomplete)'],
});

export default transferListMeta;
